import { render, staticRenderFns } from "./SponserProgramEdit.vue?vue&type=template&id=d829ce80&scoped=true"
import script from "./SponserProgramEdit.vue?vue&type=script&lang=js"
export * from "./SponserProgramEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d829ce80",
  null
  
)

export default component.exports